export default __webpack_public_path__ + "static/media/wpplogo.869d060d.png";